import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  C4_P2_S1_Title: {
    id: `case04.page02.slide01.title`,
  },
  C4_P2_S1_Video_Description: {
    id: `case04.page02.slide01.video.description`,
  },
  C4_P2_S1_Bio_Title: {
    id: `case04.page02.slide01.bio.title`,
  },
  C4_P2_S1_Bio_Text: {
    id: `case04.page02.slide01.bio.text`,
  },

  C4_P2_S1_Bio_Button_Label: {
    id: `case04.page02.slide01.bio.button.label`,
  },
  C4_P2_S1_Image_Caption1: {
    id: `case04.page02.slide01.image.caption1`,
  },
  C4_P2_S1_Image_Caption2: {
    id: `case04.page02.slide01.image.caption2`,
  },
  C4_P2_S1_Image_Caption3: {
    id: `case04.page02.slide01.image.caption3`,
  },
});
